import { render } from "./FrontGeneralView.vue?vue&type=template&id=47a0a021"
import script from "./FrontGeneralView.vue?vue&type=script&lang=js"
export * from "./FrontGeneralView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__